var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardiology(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.431,
    height: 49.567,
    viewBox: "0 0 35.431 49.567",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17682"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": 1432423
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11758",
    d: "M182.569 155.806a5.5 5.5 0 0 1 6.161 7.067 19.188 19.188 0 0 1-1.594 2.948c-.373.283-5.381 1.338-6.985-.5a19 19 0 0 1-2.746-4.982zm0 0",
    transform: "translate(-160.232 -140.654)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11759",
    d: "M130.727 60.525v5.843l.962.108 3.844-7.294 6.814-2.708a10.721 10.721 0 0 0-1.357-2.164 6.176 6.176 0 0 0-2.8-.681c-3.397 0-6.301 2.86-7.463 6.896zm0 0",
    transform: "translate(-118.071 -48.437)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11760",
    d: "M183.269 105.614v-1.7c-4.025.17-12.077 1.495-12.695 9.328l3.759 1.672s-.116-9.608 8.936-9.3zm0 0",
    transform: "translate(-154.061 -93.851)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11761",
    d: "M78.74 72.013v-9.281a1.232 1.232 0 0 0-1.232-1.232h-.739a1.231 1.231 0 0 0-.652 1.087v10zm0 0",
    transform: "translate(-68.748 -55.546)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11762",
    d: "M87.177 189.169a7.559 7.559 0 0 0-3.2-3.779l-.133.032a2.35 2.35 0 0 0-.3-.257 6.223 6.223 0 0 0-4.159-.476l-.228.056s-1.52-1.7-6.714-2.334a14.47 14.47 0 0 0-3.343-2.739 6.674 6.674 0 0 0-3.06 2.339c-3.04 3.872-2.185 10.767-.7 13.525.824 2.445 1.08 4.173 3.33 7.125a22.036 22.036 0 0 0 11.868 8.062l.312.082a7.108 7.108 0 0 0 3.474-1.547l.586-.478a12.327 12.327 0 0 0 4.363-8.78 21.248 21.248 0 0 0-1.457-9.237zm0 0",
    transform: "translate(-54.855 -162.278)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11763",
    d: "M335.032 300.919v.006a.952.952 0 1 0 0-.006zm0 0",
    transform: "translate(-302.521 -270.552)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11764",
    d: "M35.184 33.189a.968.968 0 0 0-1.912.3 18.333 18.333 0 0 1 .177 4.166 10.939 10.939 0 0 1-4.466 8.063l-.655.478a7.438 7.438 0 0 1-6.1 1.233l-2.565-.606a24.08 24.08 0 0 1-12.731-7.745 13.943 13.943 0 0 1-2.6-4.212.962.962 0 0 0 .036-.412c-.005-.042-.482-4.223 5.415-6.907a13.658 13.658 0 0 0 6.594-6.347c4.434.612 5.959 1.86 6.073 1.958a.908.908 0 0 0 .891.253l.24-.052a6.858 6.858 0 0 1 7.609 3.927.968.968 0 1 0 1.768-.79 8.869 8.869 0 0 0-3.537-3.979.1.1 0 0 1 0-.01 6.465 6.465 0 0 0 .294-1.933c0-.132-.005-.263-.013-.393h.672a.968.968 0 1 0 0-1.936h-1.092a6.471 6.471 0 0 0-1.026-1.76l.438-.438a.968.968 0 1 0-1.369-1.369l-.507.507a6.43 6.43 0 0 0-2.664-1.012 7.4 7.4 0 0 1 5.021-1.442.968.968 0 0 0 1-.967V8.075a.968.968 0 0 0-.888-.965 23.356 23.356 0 0 0-4.327.133 9.78 9.78 0 0 0-4.244-4.4l.684-1.018A.968.968 0 0 0 19.8.748l-.981 1.465a6.918 6.918 0 0 0-2.019-.079V.968a.968.968 0 1 0-1.936 0v1.656a8.3 8.3 0 0 0-2.554 1.668 10.474 10.474 0 0 0-1.581 1.9 2.2 2.2 0 0 0-1.968-1.206H6.134a2.2 2.2 0 0 0-2.2 2.2v9.9a10.19 10.19 0 0 0-1.406 1.335A11.692 11.692 0 0 0 0 26.244 14.491 14.491 0 0 0 1.6 33c.146.391.277.768.4 1.134a16.644 16.644 0 0 0 3.451 6.2 26.027 26.027 0 0 0 13.772 8.376l2.565.606a9.374 9.374 0 0 0 7.683-1.553l.655-.478A12.871 12.871 0 0 0 35.38 37.8a20.249 20.249 0 0 0-.196-4.611zM23.37 21.427a9.466 9.466 0 0 0-2.1-1.046 10.785 10.785 0 0 1 1.26-4.28 4.62 4.62 0 0 1 .716-.057 4.532 4.532 0 0 1 4.387 5.663 8.693 8.693 0 0 0-4.263-.28zm4.871-12.418V10.8a8.666 8.666 0 0 0-5.892 2.387 11.177 11.177 0 0 0-2.961 6.613 26.964 26.964 0 0 0-3.327-.595q-.441-.409-.879-.773v-.07a8.086 8.086 0 0 1 2.5-6.222c3.151-2.903 8.463-3.152 10.559-3.131zM17.538 4.03a5.085 5.085 0 0 1 1.428.207 7.1 7.1 0 0 1 3.969 3.343 13.978 13.978 0 0 0-6.56 3.134 9.624 9.624 0 0 0-3.064 6.361 11.445 11.445 0 0 0-2.349-1.131v-5.6a1.058 1.058 0 0 0 .044-.12C12.073 6.52 14.7 4.03 17.538 4.03zM5.87 7.186a.264.264 0 0 1 .264-.264h2.627a.264.264 0 0 1 .264.264v8.342a7.313 7.313 0 0 0-.966-.022 6.837 6.837 0 0 0-2.19.462zM3.983 19.693a5.882 5.882 0 0 1 4.162-2.253c1.926-.086 4.142.961 6.428 3.031a11.863 11.863 0 0 1-5.593 5.314c-3.7 1.686-5.286 3.974-5.961 5.6l-.033.082c-1.224-2.715-1.886-8.49.997-11.774zm0 0",
    transform: "translate(-.001)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11765",
    d: "M112.022 400.087a.968.968 0 1 0-1.236 1.49 22.307 22.307 0 0 0 9.07 4.518.968.968 0 0 0 .445-1.884 20.365 20.365 0 0 1-8.279-4.124zm0 0",
    transform: "translate(-99.745 -361.154)",
    style: {
      fill: "#6f7e8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11766",
    d: "M84.737 374.44a.975.975 0 1 0 1.387.123l-.02-.023a.971.971 0 0 0-1.367-.1zm0 0",
    transform: "translate(-76.231 -337.978)",
    style: {
      fill: "#6f7e8e"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiology);
export default __webpack_public_path__ + "static/media/cardiology.6421822f29571ea682017807258c535c.svg";
export { ForwardRef as ReactComponent };